<template>
  <div class="rc-header" v-if="navbarType === 'initial'">
    <div class="container">
      <div class="row align-items-center justify-content-between">
        <div class="col">
          <Logo />
        </div>
        <div
          class="col text-right"
          @click="gtagEventGoToHelp"
          v-if="!hideHelpButton"
        >
          <router-link
            :to="{ name: 'CreditLineHelpView' }"
            class="text-decoration-none"
          >
            <button type="button" class="btn btn-sm help-btn">
              <img
                :src="`${useAsset('img/credit-line/help-icon.png')}`"
                alt=""
              />
              {{ t("HELPBUTTON") }}
            </button>
          </router-link>
        </div>
        <div
          class="col text-right"
          @click="gtagEventGoToHelp"
          v-if="hideHelpButton && applicationId !== ''"
        >
          <p class="mx-auto">ID: {{ applicationId }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="rc-header" v-if="navbarType === 'goBack'">
    <div class="container">
      <div class="row align-items-center justify-content-between">
        <div class="col">
          <img
            v-if="showBackBtn"
            :src="`${useAsset('img/credit-line/back-button.png')}`"
            @click="$emit('clicked')"
            alt="back"
            id="back-btn"
          />
          <span class="fw-bold">{{ screenTitle }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import Logo from "@/apps/core-app-onboarding/components/Logo.vue";
import useAsset from "@/apps/core-app-onboarding/helpers/useAsset";
import { useI18n } from "@/apps/core-app-onboarding/composables/useI18n";
import AnalyticEvents from "@/shared-helpers/google-analytics-events.helper";
import logAnalyticsEvent from "@/apps/core-app-onboarding/services/google-analytics-events.service";
type NavBarType = "initial" | "goBack";
export default defineComponent({
  name: "Header",
  components: {
    Logo,
  },
  props: {
    navbarType: {
      type: String as PropType<NavBarType>,
      default: "initial",
    },
    screenTitle: {
      default: "",
      type: String,
    },
    backAction: {
      default: "home",
      type: String,
    },
    showBackBtn: {
      default: true,
      type: Boolean,
    },
    hideHelpButton: {
      default: false,
      type: Boolean,
    },
    applicationId: {
      type: String,
      default: "",
    },
  },
  setup() {
    const { t } = useI18n();

    const gtagEventGoToHelp = () => {
      logAnalyticsEvent(AnalyticEvents.CreditLine.HelpButton, "Application");
    };

    return {
      t,
      useAsset,
      gtagEventGoToHelp,
    };
  },
});
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
.rc-header {
  max-height: 60px;
  background-color: $pj-color-white;
  padding: 20px 10px 10px 0px;
  @media screen and (max-width: $mobile) {
  }
}
.lang-dropdown {
  text-align: right;
}

.help-btn {
  border: 1px solid $pj-color-green;
  box-sizing: border-box;
  border-radius: 13px;
  color: $pj-color-green;
}
</style>
